// schema
// import * as ISchema from '@schema';

// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";

// copy-personal-invite-link-btn imports
import { IContainer, IProps, IState } from "./CopyPersonalInviteLinkBtn.d";
import { copyPersonalInviteLinkBtnFragments } from "./CopyPersonalInviteLinkBtn.gql";
import { styles } from "./CopyPersonalInviteLinkBtn.styles";
import { snackBarOpen } from "@actions/snack-bar.actions";

// util
import { personalInviteBaseUrl } from "@constants/site.constant";
import { track, TrackingEvents } from "@util/analytics.util";
import { copyTextToClipboard } from "@util/html.util";
import { fromGlobalId } from "@util/graphql.util";

// state
import { IReduxState } from "@reducers/root.reducer";

// material-ui
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import LinkIcon from "@material-ui/icons/Link";

///////////////
// Component //
///////////////
class CopyPersonalInviteLinkBtnCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  private onClickCopyLink = () => {
    const { user, snackBarOpen } = this.props;

    const userToken = (user.id && fromGlobalId(user.id).id.substr(0, 7)) || "cw";
    const inviteUrl = `${personalInviteBaseUrl}/${userToken}`;
    const success = copyTextToClipboard(inviteUrl, true);
    let snackBarMsg = "Sorry, please try again";
    if (success) {
      snackBarMsg = "Copied invite link to your clipboard";
      track(TrackingEvents.SETTINGS.COPY_INVITE_LINK);
    }
    snackBarOpen(snackBarMsg);
  };

  public render() {
    // some browsers don't support the execCommand
    const disabled = !document.queryCommandSupported("copy");

    // pull off the flatBtnProps so we can pass them through
    const { snackBarOpen, ...btnProps } = this.props;

    // tooltip message
    const tooltipMsg = "Copy a link to share via Slack or email.";

    // render it
    return (
      <Tooltip title={tooltipMsg} aria-label={tooltipMsg}>
        <Button {...btnProps} onClick={this.onClickCopyLink} disabled={disabled}>
          <LinkIcon />
          <span style={styles.labelMarginCorrection}>Copy Invite Link</span>
        </Button>
      </Tooltip>
    );
  }
}

///////////
// Redux //
///////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

const CopyPersonalInviteLinkBtnRedux = connect(mapStateToProps, {
  snackBarOpen,
})(CopyPersonalInviteLinkBtnCmpt);

///////////
// Relay //
///////////
export const CopyPersonalInviteLinkBtn = createFragmentContainer<IContainer>(
  CopyPersonalInviteLinkBtnRedux,
  copyPersonalInviteLinkBtnFragments,
);
